import { render, staticRenderFns } from "./ActivityComponent.vue?vue&type=template&id=06b4611a"
import script from "./ActivityComponent.vue?vue&type=script&lang=js"
export * from "./ActivityComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports